import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'

type BackButtonProps = {
  buttonText: string
  routeTo?: string
  onClick?: () => void
}

export const BackButton = ({ buttonText, routeTo, onClick }: BackButtonProps) => {
  const history = useHistory()

  return (
    <Button
      style={{
        textTransform: 'none',
        fontSize: '18px',
        color: 'GrayText',
        paddingLeft: 0,
        paddingRight: 0,
      }}
      onClick={() => {
        onClick && onClick()
        routeTo ? history.push(routeTo) : history.goBack()
      }}
    >
      <ArrowBackIosIcon />
      {buttonText}
    </Button>
  )
}
